import React from "react";
import { useEffect, useState, useRef } from "react";

import { connect } from "react-redux";

import {
    searchPublishedProducts,
} from "../../../redux/actions/products";
import { setAlert } from "../../../redux/actions/alerts";

import SearchDropdown from "../../Shared/SearchDropdown";

import styles from '../../../styles/pages/FeaturedContentPages/NewProductsPageContent.module.css'

const TrashIcon = '/static/img/SvgIcons/icons-trash-black.svg';

const DefaultProductFormRow = ({
    index, 
    featured,
    handleChangeData,
    clear,
    clearFeaturedRow,

    searchPublishedProducts,
    setAlert,
    product: { productSearch },
}) => {

    const [existingContent, setExistingContent] = useState(null)
  
    useEffect(() => {
        setExistingContent(null)
    }, [clear])

    let timeout
    const searchForProducts = (value) => {
        if (timeout) {
            clearTimeout(timeout)
        }

        if (!value) {
            return
        }

        timeout = setTimeout(() => {
        if (value.length < 3) {
            setAlert("Query must be 3 characters or longer", "danger");
        } else {
            searchPublishedProducts(value);
        }
        }, 1000);
    };

    const handleProductSelect = (product) => {
        if (product) {
            handleChangeData({
                id: product.product_id,
                displayName: product.name
            },  index)
        } else {
            handleChangeData({
                id: null,
                displayName: null,
                name: null
            }, index)
        }
        setExistingContent(product)
    };

    return (
        <div className={`${styles.product_form_row_main_container}`}>
        
            {featured.name || featured.displayName ?
                <div className={styles.product_name_row_container}>
                    <>
                        {featured.name || featured.displayName ? 
                            <p>{featured.name ? 'Currently Featured' : 'To Be Added'}: {featured.name ? featured.name : featured.displayName} </p>
                        : 
                            <p></p>
                        }
                        <img src={TrashIcon} alt="Trash Icon" onClick={() => clearFeaturedRow(index)} />
                    </>
                </div>
                : null
            }
                
            <div className={styles.form_input_row_grid}>
           
                
                <div className={`input_container ${styles.form_grid_span_5} `}>
                    <label>Featured Product</label>
                    <SearchDropdown
                        options={productSearch?.length > 0 ?
                            productSearch.map((prod) => ({
                                name: `${prod.name}`,
                                value: prod,
                            }))
                        : []}
                        placeholder={'Please start typing or use dropdown to search'} 
                        handleSelect={(option) => handleProductSelect(option)}
                        emptyOption={"No Options"}
                        selection={existingContent}
                        handleSearch={(searchString) => searchForProducts(searchString)}
                        clear={clear}
                    />
                </div> 
                
            </div>
        </div>
    
  );
};

const mapStateToProps = (state) => ({
    product: state.product,
});

export default connect(mapStateToProps, {
    searchPublishedProducts,
    setAlert,
})(DefaultProductFormRow);
